import React, { useState } from "react";
import api from "components/settings/api";

import PropTypes from "prop-types";
import ModalErrorHandler from "./ModalErrorHandler";
import { toast, Bounce } from "react-toastify";
import CustomToastMessage from "../common/CustomToastMessage";

const RequestTeamLimitChange = ({ toggleModal, limitName, publicTeamId }) => {
  // Input field state
  const initialRequestData = {
    title: `Requesting team limit change for ${publicTeamId}`,
    content: "",
    email: `${publicTeamId}@teammateme.org`,
  };

  // Form Input State
  const [{ title, content, email }, setRequestData] =
    useState(initialRequestData);

  // Errors State
  const [showErrors, setShowErrors] = useState(false);
  const [errorsArr, setErrorsArr] = useState();

  // State updates on input
  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setRequestData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Toast message function
  const notify = () =>
    toast.info(
      <CustomToastMessage message="Thanks, we will look over your request." />,
      {
        autoClose: 2000,
        closeButton: true,
        hideProgressBar: false,
        transition: Bounce,
        position: "bottom-center",
      },
    );

  // Form submission
  const handleSubmit = async (event) => {
    try {
      if (event) {
        event.preventDefault();
      }

      const payload = {
        title,
        content,
        email,
      };

      // Send post request for signup
      const res = await api.post("/api/v1/feedback/team", payload);

      // If no validation errors were found
      if (res.data.validationErrors === undefined) {
        // Clear any errors
        setErrorsArr([]);
        // Hide the errors component
        setShowErrors(false);
        // Toggle toast message
        notify();
        // Toggle the modal
        toggleModal();
      } else {
        // Set errors
        setErrorsArr(res.data.validationErrors.errors);
        // Show the errors component
        setShowErrors(true);
      }
    } catch (err) {
      throw new Error(err);
    }
  };

  return (
    <div className="container--modal_wrapper">
      <div className="container--modal-dark">
        <button
          className="button--modal_cancel"
          aria-label="Close modal"
          onClick={toggleModal}
        >
          X
        </button>
        <div className="container--inner_modal">
          <h2 className="header header--modal_heading-with_sub_heading">
            {`Team limit reached.`}
          </h2>
          <h3 className="header header--modal_sub_heading">
            {`You reached the maximum number of ${limitName} allowed.`}
          </h3>
          <form
            className="form--modal_form"
            onSubmit={handleSubmit}
            method="POST"
            aria-label="Request team limit change"
          >
            {showErrors && <ModalErrorHandler errorsArr={errorsArr} />}
            <label className="label--form_label" htmlFor="title">
              Subject
              <input
                className="input input--form_input"
                type="text"
                name="title"
                value="Requesting team limit change"
                minLength="4"
                maxLength="50"
                onChange={handleInputChange}
                disabled
                required
                aria-label="Subject"
              />
            </label>
            <label className="label--form_label" htmlFor="content">
              Tell us why you need an increase.
              <textarea
                className="input input--form_input input--form_text_area"
                type="text"
                name="content"
                row="10"
                cols="1"
                value={content}
                onChange={handleInputChange}
                minLength="1"
                maxLength="600"
                required
                aria-label="Tell us why you need an increase."
              />
            </label>
            <input
              className="button button--dashboard-full_width button--dashboard-primary"
              type="submit"
              value="Send Request"
              aria-label="Send Request"
            ></input>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RequestTeamLimitChange;

RequestTeamLimitChange.propTypes = {
  toggleModal: PropTypes.func,
  limitName: PropTypes.string,
  publicTeamId: PropTypes.string,
};
